import Vue from "vue";
import store from "./store";
import config from "./config";
const api = {
    base: config.apiEndPoint,
    post(endpoint, data) {
        if (typeof data === "undefined") {
            data = {};
        }

        if (store.state.place.id) {
            data.places_id = store.state.place.id;
        }

        let options = {
            url: this.base + "/" + endpoint,
            method: "POST",
            params: data,
            headers: {
                Authorization: "Bearer " + store.state.token,
            },
        };
        return new Promise((success, err) => {
            Vue.http(options)
                .then((response) => success(response))
                .catch((response) => {
                    if (response.status === 401) {
                        store.dispatch("logout");
                    }
                    err(response);
                });
        });
    },
    get(endpoint, data) {
        if (typeof data === "undefined") {
            data = {};
        }

        if (store.state.place.id) {
            data.places_id = store.state.place.id;
        }

        let options = {
            url: this.base + "/" + endpoint,
            method: "GET",
            params: data,
            headers: {
                Authorization: "Bearer " + store.state.token,
            },
        };
        return new Promise((success, err) => {
            Vue.http(options)
                .then((response) => success(response))
                .catch((response) => {
                    if (response.status === 401) {
                        store.dispatch("logout");
                    }
                    err(response);
                });
        });
    },
};

export default api;
